import React, { useState, useEffect, useContext } from "react";
import { Table, Modal, Button, Label, TextInput } from "flowbite-react";
import GlobalContext from "../connections/GlobalContext";
import axios from "axios";
import Swal from "sweetalert2";
import Head_data from "../components/Head_data";
import Spare_log_details from "./Spare_log_details";
import Calendar from "react-calendar";
import "react-calendar/dist/Calendar.css";
import { Calendar as CalendarIcon } from "lucide-react";
import engineGif from "../image/engine.gif";

const SpareLog = () => {
  const { globalValue } = useContext(GlobalContext);
  const [spareLogs, setSpareLogs] = useState([]);
  const [showTable, setShowTable] = useState(false);
  const [selectedLog, setSelectedLog] = useState(null);
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedSpare, setSelectedSpare] = useState(null);
  const [enteredQuantity, setEnteredQuantity] = useState();
  const [quantityWarning, setQuantityWarning] = useState(false);

  const [loading, setLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [filtered, setFiltered] = useState(spareLogs);


  useEffect(() => {
    const filteredData = spareLogs.filter((branch) =>
      branch['vehicle_no'].toLowerCase().includes(searchTerm.toLowerCase()) || branch['customer_name'].toLowerCase().includes(searchTerm.toLowerCase())
    );
    setFiltered(filteredData);
  }, [searchTerm, spareLogs]);

  const fetchLogs = async () => {
    setLoading(true);
    try {
      const response = await axios.get(`${globalValue}/spares_log`, {
        params: {
          data: sessionStorage.getItem("branch"),
          position: "",
          staff: sessionStorage.getItem("name"),
        },
        headers: {
          "x-access-token": sessionStorage.getItem("token"),
        },
      });
      setSpareLogs(response.data);
    } catch (error) {
      console.error("Error fetching spare logs:", error.response?.data || error.message);
    }
    finally {
      setLoading(false);
    }
  };

  const groupSparesByService = (spares, actualSpares) => {
    return spares
      .map((spare) => {
        const matchingActualSpare = actualSpares.find(
          (actual) => actual.spare_id === spare.spare_id && actual.service_id === spare.service_id
        );
        return {
          ...spare,
          spare_name: matchingActualSpare ? matchingActualSpare.spare_name : "Unknown",
          actual_quantity: matchingActualSpare ? matchingActualSpare.quantity : 0,
          quantity_used: spare.quantity,
        };
      })
      .reduce((acc, spare) => {
        const { service_id } = spare;
        if (!acc[service_id]) {
          acc[service_id] = [];
        }
        acc[service_id].push(spare);
        return acc;
      }, {});
  };

  const handleTakeButtonClick = (spare, service) => {
    setTemp_ser(service)
    setSelectedSpare(spare);
    setEnteredQuantity(0);
    setQuantityWarning(false);
    setModalOpen(true);
  };

  const handleQuantityChange = (e) => {
    const value = parseInt(e.target.value, 10);
    if (!isNaN(value)) {
      setEnteredQuantity(value);
      setQuantityWarning(value > spareFixedQuantity());
    } else {
      setEnteredQuantity(0);
    }
  };

  const spareFixedQuantity = () => {
    return selectedSpare ? selectedSpare.actual_quantity - selectedSpare.quantity_used : 0;
  };

  useEffect(() => {
    fetchLogs();
  }, []);
  const [temp_est, setTemp_est] = useState("");
  const [temp_ser, setTemp_ser] = useState("");


  const handleSpareTaken = async (spare_id, quantity, est_id, service_id) => {
    try {


      const response = await axios.post(`${globalValue}/spare_taken`, {
        spare_id,
        quantity,
        est_id,
        service_id
      }, {
        headers: {
          "x-access-token": sessionStorage.getItem("token"),
        }
      })
      if (response.data === "success") {
        Swal.fire({
          icon: "success",
          title: "Spare Taken Successfully",
        });
        fetchLogs();
        setModalOpen(false);

      }
      else {
        Swal.fire({
          icon: "warning",
          title: response.data.message,
        });
      }
    } catch (error) {
      Swal.fire({
        icon: "warning",
        title: "Spare not Taken",
      });
    }
  }
  const [showCalendar, setShowCalendar] = useState(false);
  const [selectedDate, setSelectedDate] = useState(null);

  return (
    <div className={`md:ml-[250px] w-full md:w-[calc(100%-250px)] relative  mt-16 h-[92vh] flex justify-center items-center box-border`}>
      {loading && (
        <div className="fixed inset-0 flex items-center justify-center bg-gray-200 bg-opacity-50 z-50">
          <img src={engineGif} alt="Loading..." className="w-24 h-24" />
        </div>
      )}


      <div className="absolute right-6 bottom-8 z-50">
        <button
          onClick={() => setShowCalendar(!showCalendar)}
          className="flex items-center gap-2 bg-purple-500 p-2 text-white rounded-3xl hover:bg-blue-600 transition"
        >
          <CalendarIcon size={30} />
        </button>

        {showCalendar && (
          <div className="absolute bottom-full right-0 mt-2 shadow-lg bg-white p-2 rounded-lg z-50 w-[250px] md:w-auto">
            <Calendar
              onChange={(date) => {
                setSelectedDate(date);
                setShowCalendar(false);
                console.log("date" + date);
              }}
              value={selectedDate}
            />
          </div>
        )}
      </div>
      <div className="w-[95%] md:w-[98%] h-[95%] bg-white px-4 py-2 rounded-xl shadow-xl overflow-auto">

        <div className="w-full flex justify-between text-gray-600 mb-6">
          <Head_data data="Spare Log" font="" size="3xl" />

        </div>
        <input
          type="text"
          placeholder="Search branch by name"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          className="w-full md:w-1/3 px-4 my-2 py-2 border border-gray-300 rounded-xl shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition duration-200"
        />

        {!showTable ? (
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
            {filtered.filter(log =>
              selectedDate
                ? new Date(log.date).toDateString() === new Date(selectedDate).toDateString()
                : true
            ).map((log) => (log.vehicle_no !== "Unknown" ?
              <div key={log.log_id} className="p-4 border rounded-lg shadow-md bg-white">
                <h3 className="text-lg font-bold">Vehicle No: {log.vehicle_no}</h3>
                <p>Customer: {log.customer_name}</p>
                <p>
                  Date:{" "}
                  {new Date(log.date).toLocaleDateString("en-GB", {
                    day: "2-digit",
                    month: "2-digit",
                    year: "numeric",
                  })}
                </p>
                {log.status !== "1" ? <button
                  className="mt-4 text-blue-500 hover:text-blue-700"
                  onClick={() => {
                    setSelectedLog(log);
                    setShowTable(true);
                    setTemp_est(log.estimate_id);
                  }}
                >
                  <i className="fa fa-eye"></i> View Details
                </button> : null}
              </div> : null
            ))}
          </div>
        ) : (
          <Spare_log_details estimate_id={temp_est} setShowTable={setShowTable} />
        )}





      </div>
    </div>
  );
};

export default SpareLog;
